module.exports = __webpack_public_path__ + "static/media/agronomist-examines-growing-melon-seedlings-farm-farmers-researchers-analysis-plant.6c580e8a.jpg";